import { Alert, Button, Heading, HStack, Stack, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { confirmInterestedSibs, getInterestedSibs } from '../api'
import { EmptyState } from '../components/EmptyState'
import { ErrorState } from '../components/ErrorState'
import { InterestedSibsTable } from '../components/InterestedSibsTable'
import { LoadingState } from '../components/LoadingState'
import type { InterestedSib } from '../types'

export function InterestedSibsPage() {
  const { demandId } = useParams<{ demandId: string }>()

  const [sibs, setSibs] = useState<InterestedSib[]>([])
  const [selectedSibIds, setSelectedSibIds] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [isConfirming, setIsConfirming] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function loadInterestedSibs() {
    if (!demandId) return

    try {
      setIsLoading(true)
      setError(null)

      const result = await getInterestedSibs(demandId)
      setSibs(result)
    } catch {
      setError('Could not load interested SIBs.')
    } finally {
      setIsLoading(false)
    }
  }

  // async function handleConfirmSelected() {
  //   if (!demandId || selectedSibIds.length === 0) return

  //   try {
  //     setIsConfirming(true)
  //     setError(null)

  //     await confirmInterestedSibs(demandId, selectedSibIds)

  //     setSelectedSibIds([])
  //     await loadInterestedSibs()
  //   } catch {
  //     setError('Failed to confirm selected SIBs.')
  //   } finally {
  //     setIsConfirming(false)
  //   }
  // }

  useEffect(() => {
    void loadInterestedSibs()
  }, [demandId])

  if (isLoading) {
    return <LoadingState message="Loading interested SIBs..." />
  }

  if (error && sibs.length === 0) {
    return <ErrorState message={error} onRetry={loadInterestedSibs} />
  }

  return (
    <Stack gap={6}>
      <Stack gap={2}>
        <Heading size="lg">Interested SIBs</Heading>
        <Text color="fg.muted">Review SIBs that accepted the demand and confirm one or more.</Text>
      </Stack>

      {error && (
        <Alert.Root status="error">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Description>{error}</Alert.Description>
          </Alert.Content>
        </Alert.Root>
      )}

      {sibs.length === 0 ? (
        <EmptyState
          title="No interested SIBs yet"
          description="Interested SIBs will appear here after they accept the published demand."
        />
      ) : (
        <>
          <InterestedSibsTable
            sibs={sibs}
            selectedSibIds={selectedSibIds}
            onSelectionChange={setSelectedSibIds}
          />

          {/* <HStack justify="space-between">
            <Text color="fg.muted">
              {selectedSibIds.length === 0
                ? 'No SIBs selected'
                : `${selectedSibIds.length} SIB${selectedSibIds.length > 1 ? 's' : ''} selected`}
            </Text>

            <Button
              colorPalette="blue"
              disabled={selectedSibIds.length === 0}
              loading={isConfirming}
              onClick={handleConfirmSelected}
            >
              Confirm selected SIBs
            </Button>
          </HStack> */}
          <HStack justify="space-between">
            <Text color="fg.muted">
              {selectedSibIds.length === 0
                ? 'No SIBs selected'
                : `${selectedSibIds.length} SIB${selectedSibIds.length > 1 ? 's' : ''} selected`}
            </Text>

            <Text color="fg.muted">
              Zuschlag bitte über die Detailseite mit Leistungsverteilung vergeben.
            </Text>
          </HStack>
        </>
      )}
    </Stack>
  )
}
